import { PDKEmptyValueIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import type { Deal } from '@/models/registry';
import { Button } from '../../ui/button';
import { PRIORITY_OPTIONS_MAP } from './priority-types';

export const DealPriorityBadge = ({
  value,
  hideCopy = false,
  className,
  useAbbreviation = false,
}: {
  value: Deal['priority'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  useAbbreviation?: boolean;
}) => {
  return (
    <Button variant="ghost" className={cn('p-1 h-fit', className)}>
      {value === null && (
        <>
          <PDKEmptyValueIcon className="h-3.5 w-3.5" />
          <p className="rounded text-xs  text-gray-600">No Priority</p>
        </>
      )}
      {PRIORITY_OPTIONS_MAP.map((option) => {
        if (option.value === value) {
          return <div key={option.value}>{option.icon}</div>;
        }
      })}

      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {useAbbreviation
            ? PRIORITY_OPTIONS_MAP.find((option) => option.value === value)
                ?.abbreviation
            : PRIORITY_OPTIONS_MAP.find((option) => option.value === value)
                ?.label}
        </p>
      )}
    </Button>
  );
};
